
<template>
  <div class="tabel-wrap">
    <!-- 配置 -->
    <div class="task-sum">
        <div>
            <el-button v-if="!seeDetail" class="btn-common" size="mini" type="info" @click="countBtn()">
                {{ countBtnName }}
            </el-button>
            计划任务量总量：<span class="theme-color">{{ planCountTotal }}</span>  
            计划任务总额：<span class="theme-color">{{ taskAmountTotal| numDigit }}元</span>
        </div>
    </div>
    <el-table style="width:1000px;border: 1px solid #EBEEF5;" tooltip-effect="light"  :default-expand-all="false"  :data="taskDetailList"  header-cell-class-name="table_header">
        <el-table-column  label="采集品种汇总" show-overflow-tooltip width="120"
            header-align="left" align="left">
            <template slot-scope="scope">
                <span>{{ getAllName(scope.row.platformTaskDetailItemList,'goodsName').toString('、') || '-' }}</span>
            </template>
        </el-table-column>
        
        <el-table-column  label="平台任务名称" show-overflow-tooltip width="120"
            header-align="left" align="left">
            <template slot-scope="scope">
                <span>{{ scope.row.taskContentName || '-' }}</span>
            </template>
        </el-table-column>

        <el-table-column show-overflow-tooltip label="系统功能"  width="120"  header-align="left" align="left">
            <template slot-scope="scope">{{ scope.row.menuName || '-' }}</template>
        </el-table-column>

        <el-table-column label="采集家数汇总" :render-header="renderHeader" width="120" header-align="left" align="left">
            <template slot-scope="scope">
                {{ getAllNum(scope.row.platformTaskDetailItemList,'customerCount') || '-' }}
            </template>
        </el-table-column>

        <el-table-column label="业务员报价" width="120" header-align="left" align="left">
            <template slot-scope="scope">
                {{ scope.row.taskPrice}}{{ scope.row.taskPriceUnit}}
            </template>
        </el-table-column>

        <el-table-column label="任务量设置" width="120" header-align="left" align="left">
            <template slot-scope="scope">
                {{getSum(scope.row.platformTaskDetailItemList,1,scope.$index )}}{{ scope.row.taskTotalUnit}}
            </template>
        </el-table-column>

        <el-table-column label="任务金额" width="120" header-align="left" align="left">
            <template slot-scope="scope">
                {{ getSum(scope.row.platformTaskDetailItemList,2,scope.$index )| numDigit}}元
            </template>
        </el-table-column>
        <el-table-column label="计算方式" fixed="right"  header-align="left" align="left">
            <template slot-scope="scope">
                <span>{{ scope.row.taskTotalType || '-' }}</span>
            </template>
        </el-table-column>

        <el-table-column type="expand" fixed="right">
            <div class="detail-table-wrap"  slot-scope="props">
                <div class="detail-table detail-header">
                    <div class="parm1">采集品种</div>
                    <div class="parm2">项目运营人</div>
                    <div class="parm3">任务省区</div>
                    <div class="parm4">采集家数</div>
                    <div class="parm5">任务执行人数</div>
                    <div class="parm6">任务量设置</div>
                    <div class="parm7">执行人次</div>
                    <div class="parm8">任务金额</div>
                </div>
                <div class="detail-table" v-for="item in props.row.platformTaskDetailItemList" :key="item.guid">
                    <el-tooltip effect="light" v-if="item.goodsName" :content="item.goodsName" placement="bottom-start">
                        <div class="parm1 expand-text">{{ item.goodsName || '-' }}</div>
                    </el-tooltip>
                    <div v-else class="parm1 expand-text">{{ '-' }}</div>
                    <div class="parm2">{{ item.projectManagerUserName ||'-' }}</div>
                    <div class="parm3">{{ item.taskProvince || '-'}}</div>
                    <div class="parm4">{{ item.customerCount  || '-'}}</div>
                    <div class="parm5">{{ item.taskExecuteStaffNum }}人</div>
                    <div class="parm6">
                        <el-input onkeyup="value=value.replace(/[^\d.]/g, '')"  v-if="!disabled" @input="item.taskAmount = item.taskPrice*item.taskTotal" v-model="item.taskTotal" style="width: 80px;" size="mini" type="input"></el-input>
                        <span v-else>{{ item.taskTotal }}</span>
                        <span class="unit">{{ item.taskTotalUnit }}</span>
                    </div>
                    <div class="parm7">{{  (item.taskExecuteStaffNum ? item.taskTotal/item.taskExecuteStaffNum : item.staffCount ? item.staffCount : '-') | numDigit }}</div>
                    <div class="parm8">{{ item.taskPrice*item.taskTotal| numDigit }}元</div>
                </div>
            </div>
        </el-table-column>
    </el-table>

  </div>


</template>

<script>
export default {
  data() {
    return{
        taskDetailList:[],
        planCountTotal:null,
        taskAmountTotal:null,
        countBtnName:''
    }
  },
  props:['configData','disabled','btnName'],
  computed: {
    tableHeight() {
      return this.taskDetailList.length > 8 ? '490px' : '';
    },
    seeDetail() {
      return this.$route.query.is_detail
    }
  },
  watch:{
    configData: {
      deep: true,
      handler(val) {
        console.log(val);
        this.planCountTotal = val.planCountTotal;
        this.taskAmountTotal = val.taskAmountTotal;
        this.taskDetailList = val.taskDetailList;
      }
    },
    btnName:{
        immediate:true,
        handler(val) {
        this.countBtnName = val
      }
    }
  },
  created() {
  },
  methods:{
    getSum(platformTaskDetailItemList,type,index){
        //算单条合计任务量
        if (type == 1) {
            let taskTotal = 0;
            let planCountTotal = 0;
            try {
                platformTaskDetailItemList.forEach(item => {
                    if (+item.taskTotal >= 0) {
                        taskTotal += +item.taskTotal;
                    } else {
                        throw new Error('请输入正确的任务量');
                    }
                })
            } catch (e) {
                this.$NewMessage.error(e.message);
                return;
            }
            this.taskDetailList[index].taskTotal = taskTotal;
            this.taskDetailList.forEach(item=>{
                planCountTotal +=item.taskTotal;
            })
            this.planCountTotal = planCountTotal;
            return taskTotal;
        }
        //算单条任务金额
        if (type == 2) {
            let taskAmountTotal = 0;
            let alltaskAmountTotal = 0;
            try {
                platformTaskDetailItemList.forEach(item => {
                    if (+item.taskAmount >= 0) {
                        taskAmountTotal += +item.taskAmount;
                    } else {
                        throw new Error('请输入正确的任务量');
                    }
                })
            } catch (e) {
                this.$NewMessage.error(e.message);
                return;
            }
            this.taskDetailList[index].taskAmountTotal = taskAmountTotal;

            this.taskDetailList.forEach(item=>{
                alltaskAmountTotal +=item.taskAmountTotal;
            })
            this.taskAmountTotal = alltaskAmountTotal;
            return taskAmountTotal;
        }
    },
    /**
     * @param {Array} platformTaskDetailItemList 展开list
     * @param {Number} index 索引
     * @param {String} sourceKey 原字段
     * @param {String} targetKey 目标字段
     */
    getAllName(platformTaskDetailItemList,sourceKey,targetKey) {
        let arr = []
        Array.isArray(platformTaskDetailItemList) && platformTaskDetailItemList.forEach(item=>{
            let list = item[sourceKey] ? item[sourceKey].split('、') : []
            arr = arr.concat(list)
        })
        return [...new Set(arr)]
    },
    getAllNum(platformTaskDetailItemList,sourceKey,targetKey) {
        let str = 0
        Array.isArray(platformTaskDetailItemList) && platformTaskDetailItemList.forEach(item=>{
            str = str + (item[sourceKey] ? item[sourceKey] : 0)
        })
        return str
    },
    countBtn() {
        this.$emit('countBtn')
    },
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'light',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
              '对上个月的有效任务的采集终端进行按家去重'
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
  }
};
</script> 
<style scoped>
.theme-color{
  color: #4fa1a4;
}
.tabel-wrap{
    background: #fff;
    padding: 0px 20px 10px 20px;
}
.task-sum{
    width:1000px;
    display: flex;
    justify-content: flex-end;
    padding-bottom: 10px;
    font-size: 16px;
}
/deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 10px 0;
  color: #323233;
}
.flex{
    display: flex;
    align-items: center;
  
}
.unit{
        margin-left:4px ;
}

.detail-table{
    display: flex;
    /* margin-left: 200px; */
    font-size: 14px;
    align-items: center;
    text-align: left;
}
.parm1{
    width: 120px;
    padding: 10px;
}
.parm2{
    width: 120px;
    padding: 10px;
}
.parm3{
    width: 120px;
    padding: 10px;
}
.parm4{
    width: 120px; 
    padding: 10px;
}
.parm5{
    width: 120px; 
    padding: 10px;
}
.parm6{
    width: 120px; 
    padding: 10px;
}
.parm7{
    width: 120px; 
    padding: 10px;
}
.parm8{
    width: 120px; 
    padding: 10px;
}
.detail-header{
    font-weight: 500;
    word-break: keep-all;
    color: #323233;
    background-color: #F0F0F0 !important;
    text-align: letf;
    margin-left: 0;
    /* padding-left: 200px; */
    margin-bottom: 15px;
}
.expand-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>

